export default "__VITE_ASSET__DghnddmX__"